module.exports = __webpack_public_path__ + "static/media/Synopsis - It Makes Sense to Believe.ef16651b.pdf";